import { useSceneState } from './useScene'

export function useActiveLayer() {
  const activeLayer = useSceneState('activeLayer')

  return {
    is3DActiveLayer: activeLayer === '3D',
    is2DActiveLayer: activeLayer === '2D',
    activeLayer
  }
}
